export default {
  formId: "Whitelist-number",
  formField: {
    number: {
      name: "number",
      label: "Phone Number",
      type: "phoneNumber",
      errorMsg: "Phone number is required.",
      invalidMsg: "Your phone number is invalid",
    },
    description: {
      name: "description",
      label: "Description",
      type: "text",
      errorMsg: "Description is required.",
      invalidMsg: "Description is invalid",
    },
    location: {
      name: "location",
      label: "Location",
      type: "select",
      errorMsg: "location is required.",
      invalidMsg: "Location is not valid",
    },
    timezone: {
      name: "timezone",
      label: "Timezone",
      type: "select",
      errorMsg: "Timezone is required.",
      invalidMsg: "Timezone is not valid",
    },
    project: {
      name: "project",
      label: "SubAccount",
      type: "text",
      errorMsg: "SubAccount is required.",
      invalidMsg: "SubAccount is invalid",
    },
    status: {
      name: "status",
      label: "Status",
      type: "switch",
      errorMsg: "Status is required.",
      invalidMsg: "Status is invalid",
    },
  },
};
